import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import Act from 'components/Admin/Reports/ActsReport/ActsTable/Act';
// @ts-expect-error TS7016
import Header from 'components/Admin/Reports/ActsReport/ActsTable/Header';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useSelector } from 'store/utils';

const ActsTable: FC = () => {
    const acts = useSelector((state) => state.acts.acts);

    const trl = useTrls();

    if (acts.length === 0) {
        return <div>{trl('admin.actsReport.actsTable.empty')}</div>;
    }

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <Header />
            </TableHead>
            <TableBody>
                {acts.map((act, index) => (
                    <Act key={index} act={act} />
                ))}
            </TableBody>
        </Table>
    );
};

export default ActsTable;
